/* ==========================================================================
   nb-product-content.js — adfaerd for produktsidens indholdssektioner

   Tre smaa ting, som alle er progressiv forbedring:

     1) Stoerrelsesguide-modal  [data-nb-sizeguide-open] -> window.NBModal
        (fra nb-menu.js). Uden JS er modalen skjult, og sektionsvarianten
        af guiden staar stadig paa siden.
     2) FAQ-accordion           én aaben ad gangen. HTML'ens name-attribut paa
        <details> goer det selv i nye browsere; her lukkes soeskende i de
        aeldre. Uden JS virker accordion'en stadig — bare med flere aabne.
     3) Related-produkter       henter Shopifys product-recommendations, naar
        sektionen renderes uden dem (kun relevant for kilde = anbefalinger).

   Regler: vanilla, ingen afhaengigheder, idempotent (init koeres paa
   DOMContentLoaded OG shopify:section:load), og ingen kundevendt tekst —
   alt hvad brugeren ser kommer fra Liquid.
   ========================================================================== */

(function (window, document) {
  'use strict';

  var BOUND = 'nbPdpBound';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  /* ------------------------------------------------------------------ *
   * 1) Stoerrelsesguide-modal
   *
   * Triggeren kan sidde hvor som helst paa siden — ogsaa i koebsboksen,
   * som en anden sektion ejer. Derfor:
   *   data-nb-sizeguide-open="#id"  -> aabner praecis den modal
   *   data-nb-sizeguide-open=""     -> aabner den foerste modal paa siden
   * ------------------------------------------------------------------ */

  function findGuide(trigger) {
    var sel = trigger.getAttribute('data-nb-sizeguide-open');
    if (sel) {
      var byId = document.querySelector(sel);
      if (byId) return byId;
    }
    return document.querySelector('[data-nb-sizeguide-modal]');
  }

  function initSizeGuide(root) {
    /* Købsboksens link peger paa sektionens anker (#nb-sizeguide). Findes der
       en modal, overtager vi klikket; ellers scroller browseren som normalt. */
    var triggers = toArray(root.querySelectorAll('[data-nb-sizeguide-open]'))
      .concat(toArray(root.querySelectorAll('a[href="#nb-sizeguide"]')));

    triggers.forEach(function (trigger) {
      if (trigger.dataset[BOUND] === 'guide') return;
      trigger.dataset[BOUND] = 'guide';

      trigger.addEventListener('click', function (e) {
        var modal = findGuide(trigger);
        if (!modal) return; /* ingen modal paa siden — lad linket/knappen vaere */
        e.preventDefault();

        if (window.NBModal && typeof window.NBModal.open === 'function') {
          window.NBModal.open(modal, { opener: trigger });
          return;
        }

        /* Fallback uden nb-menu.js: vis modalen, luk paa Escape og paa
           luk-knapperne. Ingen fokusfaelde — men heller ingen blindgyde. */
        modal.removeAttribute('hidden');
        modal.classList.add('is-open');
        var overlaySel = modal.getAttribute('data-nb-modal-overlay');
        var overlay = overlaySel ? document.querySelector(overlaySel) : null;
        if (overlay) {
          overlay.removeAttribute('hidden');
          overlay.classList.add('is-open');
        }

        var close = function () {
          modal.classList.remove('is-open');
          modal.setAttribute('hidden', '');
          if (overlay) {
            overlay.classList.remove('is-open');
            overlay.setAttribute('hidden', '');
          }
          document.removeEventListener('keydown', onKey);
          if (typeof trigger.focus === 'function') trigger.focus();
        };
        var onKey = function (ev) {
          if (ev.key === 'Escape' || ev.key === 'Esc' || ev.keyCode === 27) close();
        };

        document.addEventListener('keydown', onKey);
        if (overlay) overlay.addEventListener('click', close, { once: true });
        toArray(modal.querySelectorAll('[data-nb-modal-close]')).forEach(function (btn) {
          btn.addEventListener('click', close, { once: true });
        });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * 2) FAQ — én aaben ad gangen
   * ------------------------------------------------------------------ */

  function initFaq(root) {
    toArray(root.querySelectorAll('[data-nb-faq]')).forEach(function (list) {
      if (list.dataset[BOUND] === 'faq') return;
      list.dataset[BOUND] = 'faq';

      list.addEventListener('toggle', function (e) {
        var item = e.target;
        if (!item || item.tagName !== 'DETAILS' || !item.open) return;
        toArray(list.querySelectorAll('details')).forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      }, true);
    });
  }

  /* ------------------------------------------------------------------ *
   * 3) Related — hent product-recommendations
   *
   * Shopify renderer sektionen uden anbefalinger foerste gang
   * (recommendations.performed == false). Liquid udstiller da en URL i
   * data-nb-related-url, som vi henter og bytter ind. Fejler kaldet, sker
   * der ingenting — pladsholderen fjernes bare.
   * ------------------------------------------------------------------ */

  function initRelated(root) {
    toArray(root.querySelectorAll('[data-nb-related-url]')).forEach(function (holder) {
      if (holder.dataset[BOUND] === 'related') return;
      holder.dataset[BOUND] = 'related';

      var url = holder.getAttribute('data-nb-related-url');
      if (!url) return;

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('recommendations');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-nb-related-root]');
          var current = holder.closest('[data-nb-related-root]');
          if (!fresh || !current) {
            holder.remove();
            return;
          }
          current.innerHTML = fresh.innerHTML;
          initSizeGuide(current);
          /* Hjerterne paa de nye kort skal have deres gemte tilstand tilbage. */
          if (window.NBWishlist && typeof window.NBWishlist.sync === 'function') {
            window.NBWishlist.sync();
          }
          current.dispatchEvent(new CustomEvent('nb:related:loaded', { bubbles: true }));
        })
        .catch(function () {
          holder.remove();
        });
    });
  }

  /* ------------------------------------------------------------------ *
   * init
   * ------------------------------------------------------------------ */

  function init(root) {
    var scope = root || document;
    initSizeGuide(scope);
    initFaq(scope);
    initRelated(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });

  window.NBProductContent = { init: init };
})(window, document);
